import { Button } from "../ui/button";
import { Check } from "lucide-react";

type AlertMessagesProps = {
  error: string | null;
  successMessage: string | null;
  onDismissError: () => void;
  onDismissSuccess: () => void;
};

export const AlertMessages = ({
  error,
  successMessage,
  onDismissError,
  onDismissSuccess,
}: AlertMessagesProps) => {
  return (
    <>
      {error && (
        <div className="flex items-center justify-between rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive">
          <span>{error}</span>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismissError}
            className="h-auto p-1 hover:bg-destructive/20"
          >
            ×
          </Button>
        </div>
      )}

      {successMessage && (
        <div className="flex items-center justify-between rounded-xl border border-lime-600/40 bg-lime-600/10 px-4 py-3 text-sm text-lime-800">
          <span className="flex items-center gap-2">
            <Check className="h-4 w-4" />
            {successMessage}
          </span>
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismissSuccess}
            className="h-auto p-1 hover:bg-green-500/20"
          >
            ×
          </Button>
        </div>
      )}
    </>
  );
};
